import {Component, Input, OnInit} from '@angular/core';
import { EvaluationBaseTileComponent } from 'app/core/components/evaluation/content/tile.component';
import { LicenseService } from 'app/core/services/license.service';
import { EnvironmentService } from 'app/core/services/environment.service';

@Component({
  selector: 'itpx-evaluation-video-tile',
  templateUrl: './tile.component.html',
  styleUrls: ['./tile.component.css']
})
export class EvaluationVideoTileComponent extends EvaluationBaseTileComponent implements OnInit {

  @Input() deliverable: any;
  images: string;
  href: string = '#';

  constructor(private licenseService: LicenseService,
              private environmentService: EnvironmentService) {
    super();
    this.images = this.environmentService.config['server'].images;
  }

  ngOnInit() {
    super.init(this.licenseService, this.deliverable, false);
    this.href = `/#/evaluation/video/${this.deliverable.assignmentId}/${this.deliverable.id}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/content/video/tile.component.ts